import { getActionHandler, getInitialState } from '../helpers/crudReducers'

const initialState = getInitialState('LEADS')
const CRUD_ACTION_HANDLERS = getActionHandler('LEADS')

export default function leads (state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
